import { useEffect, useRef } from 'react';
import { useApp } from '../contexts/AppContext';
import type { TabId } from '../types/app';

/**
 * Appelé quand l'utilisateur retape l'onglet déjà actif
 * (barre du bas ou sidebar). Sert à revenir à l'écran racine.
 */
export function useTabReselect(tab: TabId, handler: () => void): void {
  const { subscribeTabReselect } = useApp();
  const handlerRef = useRef(handler);
  handlerRef.current = handler;

  useEffect(
    () => subscribeTabReselect(tab, () => handlerRef.current()),
    [tab, subscribeTabReselect],
  );
}
